import { useState } from 'react';

/**
 * Branded loading screen, visually matching the instant HTML splash in
 * index.html. Used as the app's Suspense fallback so the post-mount loading
 * phase (i18n, lazy chunks, query-cache restore) shows the SkyGIS brand instead
 * of a blank screen. The wordmark always renders, so the screen never looks
 * dead even if the logo image fails to load.
 */
export function SplashScreen() {
  const [imgOk, setImgOk] = useState(true);
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        background: '#0c0a09',
        zIndex: 9999,
      }}>
      {imgOk && (
        <img
          src='/web-app-manifest-192x192.png'
          alt=''
          width={96}
          height={96}
          onError={() => setImgOk(false)}
          style={{ width: 96, height: 96, borderRadius: 22, animation: 'app-splash-pulse 1.6s ease-in-out infinite' }}
        />
      )}
      <span
        style={{
          color: '#e7e5e4',
          font: '600 15px -apple-system, system-ui, sans-serif',
          letterSpacing: '0.02em',
          animation: 'app-splash-pulse 1.6s ease-in-out infinite',
        }}>
        SkyGIS
      </span>
      <style>{`@keyframes app-splash-pulse{0%,100%{opacity:.55;transform:scale(.96)}50%{opacity:1;transform:scale(1)}}`}</style>
    </div>
  );
}
